import { Button } from '@tempo-io/sui-button';
import { Calendar } from '@tempo-io/sui-calendar';
import { formatISO } from 'date-fns';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { toISOTimestamp, toLocalMidnight } from '@/common/utils/dateFormats';

export interface DatePickerProps {
  value?: string | null;
  onSelect: (value: string | null) => void;
  showClearButton?: boolean;
}

export const DatePicker = ({ value, onSelect, showClearButton = false }: DatePickerProps) => {
  const { t } = useTranslation();

  const selectedDate = useMemo(() => (value ? toLocalMidnight(value) : undefined), [value]);

  const handleSelect = (date: Date | undefined) => {
    if (!date) {
      onSelect(null);
      return;
    }
    onSelect(toISOTimestamp(formatISO(date, { representation: 'date' })));
  };

  return (
    <div className="flex flex-col">
      <Calendar
        mode="single"
        selected={selectedDate}
        defaultMonth={selectedDate ?? new Date()}
        onSelect={handleSelect}
      />
      {showClearButton && (
        <Button variant="ghost" className="mx-2 mb-2" onClick={() => onSelect(null)}>
          {t(($) => $.common.clearDate)}
        </Button>
      )}
    </div>
  );
};
